var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobalSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 016.162 13.1l3.898 3.898-1.061 1.06-3.897-3.897A8 8 0 118 0zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13z",
    fill: "#fff"
  })));
}
export default SvgIconGlobalSearch;